import { useState } from "react";
import { NumberSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";

type AppCustomPropertySettingsNumberProps = {
    settings: NumberSettings
    onChange: (settings: NumberSettings) => void;
}

export const AppCustomPropertySettingsNumber = ({settings, onChange} : AppCustomPropertySettingsNumberProps) => {
    return (
        <div className="app-custom-property-settings-container">

            <div className="app-custom-property-group">

                <div className="app-custom-property-label">
                    Min Num
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.minNumOn}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                minNumOn: checked
                            });
                        }}
                    />
                </div>
            </div>

            {settings.minNumOn &&
                <div className="app-custom-property-group">
                    <div className="app-custom-property-label">
                        Min Num  
                    </div>
                    <div className="app-custom-property-value">
                        <input 
                            type="number"
                            value={settings.minNum}
                            onChange={(event) => {
                                onChange({
                                    ...settings,
                                    minNum: parseInt(event.target.value)
                                });
                            }}
                        />
                    </div>
                </div>
            }

            <div className="app-custom-property-group">

            <div className="app-custom-property-label">
                Max Num
            </div>
            <div className="app-custom-property-value">
                <MySwitch
                    checked={settings.maxNumOn}
                    onChange={(checked: boolean) => {
                        onChange({
                            ...settings,
                            maxNumOn: checked
                        });
                    }}
                />
            </div>
            </div>

            {settings.maxNumOn &&
                <div className="app-custom-property-group">
                    <div className="app-custom-property-label">
                        Max Num  
                    </div>
                    <div className="app-custom-property-value">
                        <input 
                            type="number"
                            value={settings.maxNum}
                            onChange={(event) => {
                                onChange({
                                    ...settings,
                                    maxNum: parseInt(event.target.value)
                                });
                            }}
                        />
                    </div>
                </div>
            }
        </div>
    )
}